// ═══════════════════════════════════════════════════════════════════════════
// AVVISI SULLE ATTIVITÀ — un solo punto per tutte le schermate (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Lo stato di un'attività si cambia da più posti (pannello, pulsanti di stato, spunta nella
// lista, Kanban, Notifiche): tutti chiamano avvisaCambioStato, così chi segue l'attività
// (assegnatario, chi l'ha creata, colleghi con cui è condivisa) riceve lo stesso avviso
// ovunque sia avvenuto il cambio. Chi agisce non avvisa se stesso.
// Si avvisa solo per i passaggi che contano: completata, sospesa, annullata, riaperta.
// ═══════════════════════════════════════════════════════════════════════════
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { destinatariAttivita } from "./condivisione";

const TESTI_STATO = {
  completata: "ha completato",
  sospesa: "ha sospeso",
  annullata: "ha annullato",
};

/** Testo dell'avviso per un cambio di stato (null se il cambio non merita un avviso). */
export function testoCambioStato(statoPrima, statoDopo) {
  if (!statoDopo || statoPrima === statoDopo) return null;
  if (TESTI_STATO[statoDopo]) return TESTI_STATO[statoDopo];
  if (["completata", "sospesa", "annullata"].includes(statoPrima) && ["aperta", "in_corso"].includes(statoDopo)) return "ha riaperto";
  return null;
}

/** Scrive gli avvisi per un'attività (non blocca mai il chiamante). */
export function avvisaSeguaci(task, utente, titolo, testo) {
  if (!task?.id || !task.organizationId) return Promise.resolve();
  const dest = destinatariAttivita(task, utente?.uid || "");
  return Promise.all(dest.map(uid => addDoc(collection(db, "notifiche"), {
    userId: uid, orgId: task.organizationId, tipo: "attivita_condivisa", titolo, testo,
    projectId: task.projectId || null, taskId: task.id, letta: false, createdAt: serverTimestamp(),
  }))).catch(err => console.warn("Avvisi attività non inviati:", err?.code || err));
}

export function avvisaCambioStato(task, statoDopo, utente) {
  const verbo = testoCambioStato(task?.status || "aperta", statoDopo);
  if (!verbo) return Promise.resolve();
  const titolo = { completata: "Attività completata", sospesa: "Attività sospesa", annullata: "Attività annullata" }[statoDopo] || "Attività riaperta";
  return avvisaSeguaci(task, utente, titolo, `${utente?.displayName || "Un collega"} ${verbo} «${task.title || "un'attività"}»`);
}

/**
 * Stesso avviso per una sottoattività (ottobre 2026): lo ricevono chi l'ha creata e chi ne
 * è incaricato (escluso chi agisce); cliccandolo si apre l'attività madre.
 */
export function avvisaCambioStatoSottoattivita(st, statoDopo, utente, { projectId = null } = {}) {
  const verbo = testoCambioStato(st?.status || "aperta", statoDopo);
  if (!verbo || !st?.parentTaskId) return Promise.resolve();
  const titolo = { completata: "Sottoattività completata", sospesa: "Sottoattività sospesa", annullata: "Sottoattività annullata" }[statoDopo] || "Sottoattività riaperta";
  return avvisaSeguaci({ ...st, condivisaCon: [], id: st.parentTaskId, projectId: projectId || st.projectId || null }, utente, titolo,
    `${utente?.displayName || "Un collega"} ${verbo} la sottoattività «${st.title || ""}»${st.parentTaskTitle ? ` di «${st.parentTaskTitle}»` : ""}`);
}
